import api from '../../../App/socket';

export const assignLead = (userId, leadId) => api.send({
    api: 'db',
    model: 'Lead',
    action: 'Update',
    options: {
        update: {
            ref_assigned_to: userId,
        },
        where: {
            _id: leadId,
        },
    },
}).then((response) => response).catch((error) => error);

export const assignDeliveryArrangedAgent = (userId, leadId) => api.send({
    api: 'db',
    model: 'Lead',
    action: 'Update',
    options: {
        update: {
            ref_delivery_requested_assigned_to: userId,
        },
        where: {
            _id: leadId,
        },
    },
}).then((response) => response).catch((error) => error);

export const updateOnAssignLead = (userId, leadId) => api.send({
    api: 'db',
    model: 'Lead',
    action: 'Update',
    options: {
        update: {
            ref_assigned_to: userId,
        },
        where: {
            _id: leadId,
        },
    },
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/requests/assign_lead_request.js